/**
 * Cargador del modo demo (`src/Panel/DemoHost.php`): lo único que llega a una página con la demo encendida.
 * Cualquier elemento con `data-fancy-framework-demo` abre el panel; al pulsarlo por primera vez se descarga el
 * resto (`front-app.js`: panel, motor y vocabulario), el mismo anfitrión del front de un administrador, pero con
 * `config.demo`: previsualiza, revisa, aplica y deshace en esta página, y no guarda nada (`host.js`).
 *
 * Delegación de eventos, como `front.js`: el botón puede pintarse después de este script.
 */
(() => {
  const config = window.fancyFrameworkDemo;
  if (!config) {
    return;
  }

  const SELECTOR = '[data-fancy-framework-demo]';
  let app = null;

  // A button that opens a dialog says so. Anything else used as one (a div from a builder) also gets the role
  // and a place in the tab order, so a keyboard can reach it.
  const prepare = () => {
    document.querySelectorAll(SELECTOR).forEach((opener) => {
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-expanded', 'false');
      if (!opener.matches('a[href], button')) {
        opener.setAttribute('role', 'button');
        opener.setAttribute('tabindex', '0');
      }
    });
  };
  if ('loading' === document.readyState) {
    document.addEventListener('DOMContentLoaded', prepare);
  } else {
    prepare();
  }

  const open = (opener) => {
    app = app || import(config.appUrl).then((module) => module.mount(config));
    app
      .then((host) => host.toggle(opener))
      .catch((error) => {
        app = null;
        console.error('Fancy Framework: the panel could not load.', error); // eslint-disable-line no-console
      });
  };

  document.addEventListener('click', (event) => {
    const opener = event.target instanceof Element ? event.target.closest(SELECTOR) : null;
    if (opener) {
      event.preventDefault();
      open(opener);
    }
  });

  // role="button" promises Enter and Space; a real button or link already answers to them.
  document.addEventListener('keydown', (event) => {
    const opener = event.target instanceof Element ? event.target.closest(SELECTOR) : null;
    if (opener && !opener.matches('a[href], button') && (' ' === event.key || 'Enter' === event.key)) {
      event.preventDefault();
      open(opener);
    }
  });
})();
